import React from "react";
import { Nav, Sidenav, Dropdown, Icon } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee,
  faStore,
  faCalendarDay,
  faBuilding,
  faRupeeSign,
  faLock,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";
import styles from "./leaseMenu.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  withRouter,
  useParams,
} from "react-router-dom";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import apiUrl from "../apiUrlConstant";
import { getUserType } from "../utils/index";

var headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseMenu extends React.Component {
  state = {
    openMenu: ["1"],
    disableOption: false,
    urlAppend: "",
    activeKey: "1-1",
    propsMenu: ",",
    menus: {},
    links: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      openMenu: [this.props.openMenu],
      disableOption: false,
      urlAppend: "",
      activeKey: "1-1",
      propsActiveKey: "1-1",
      menus: {},
      links: {},
      lastUrl: ''
    };
  }

  componentDidMount() {


    if (this.props.match.params.id === undefined) {
      this.setState({
        disableOption: true,
      });
    } else {
      this.setState({
        disableOption: false,
        urlAppend: "/" + this.props.match.params.id,
      });
    }
    var ths = this;
    let moduleName = this.props.moduleName.replace("/", "");
    fetch(`${apiUrl.apiUrl.url}/lease-view/amend-lease-menus?leaseId=` + this.props.match.params.id + `&moduleName=` + moduleName, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        ths.setState({
          menus: data.data,
          links: data.links
        });

      })
      .catch((error) => {
        console.log(error);
      });

  }
  componentDidUpdate() {
    let matchFound = false;

    Object.entries(this.state.links).forEach(([key, value]) => {
      if (matchFound) {
        matchFound = false;
        //if(key == "submit")
        this.props.history.push(key);
      }
      if (key == this.props.match.url) {
        if (!value) {
          matchFound = true;
        } else {
          //this.setState({lastUrl: key });
        }
      }
    });
    if (this.props.openMenu != this.state.propsMenu) {
      this.setState({
        propsMenu: this.props.openMenu,
        openMenu: [this.props.openMenu],
      });
    }
    if (this.props.activeKey != this.state.propsActiveKey) {
      this.setState({
        propsActiveKey: this.props.activeKey,
        activeKey: this.props.activeKey,
      });
    }
    if (this.props.match.params.id === undefined) {
      if (this.state.disableOption == false) {
        this.setState({
          disableOption: true,
        });
      }
    } else {
      if (this.state.disableOption == true) {
        this.setState({
          disableOption: false,
          urlAppend: "/" + this.props.match.params.id,
        });
      }
    }
  }

  render() {
    // let url = this.props.match;
    //console.log("rendering menu");
    return (
      <div className="leftSidebar">
        <Sidenav
          activeKey={this.state.activeKey}
          openKeys={this.state.openMenu}
          onOpenChange={(openKeys, event) => {
            this.setState({ openMenu: [openKeys[openKeys.length - 1]] });
          }}
        >
          <Sidenav.Body>
            <Nav>
              {Object.keys(this.state.menus).length > 0 && Object.keys(this.state.menus).map((item, key) => {
                let mainKey = key + 1;
                return (
                  <Dropdown
                    eventKey={`${mainKey}`}
                    title={`${item}`}
                    icon={<FontAwesomeIcon icon={`${this.state.menus[item]['icon']}`} />}
                  >

                    {Object.keys(this.state.menus[item]['menus']).length > 0 && Object.keys(this.state.menus[item]['menus']).map((submenu, submenuKey) => {
                      let subKey = submenuKey + 1;
                      return (
                        <Dropdown.Item
                          eventKey={`${mainKey}-${subKey}`}
                          componentClass={Link}
                          to={`${this.state.menus[item]['menus'][submenu]['link']}/${this.props.match.params.id}`}
                          disabled={this.state.menus[item]['menus'][submenu]['isDisable']}
                          onSelect={() => {
                            this.setState({ activeKey: `${mainKey}-${subKey}` })
                            //  this.state.activeKey ={`${key}-${submenuKey}`};
                          }}
                        >
                          {this.state.menus[item]['menus'][submenu]['page']}
                        </Dropdown.Item>
                      );
                    })}

                  </Dropdown>
                )

              })}


              {/* <Dropdown
                eventKey="7"
                title="Submit Lease"
                icon={<FontAwesomeIcon icon={faEllipsisH} />}
              >
                <Dropdown.Item
                  eventKey="7-1"
                  componentClass={Link}
                  to={`/createlease/submit-lease` + this.state.urlAppend}
                  disabled={this.state.disableOption}
                  onSelect={() => {
                    this.state.activeKey = "7-1";
                  }}
                >
                  Submit Lease
                </Dropdown.Item>
              </Dropdown> */}

            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    );
  }
}

export default withRouter(LeaseMenu);
